module.exports = __webpack_public_path__ + "static/img/weikuang.1e607ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rocbox/weikuang.png
// module id = u4LC
// module chunks = 1